import { Component, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';

@Component({
  selector: 'app-termo',
  templateUrl: './termo.component.html',
  styleUrls: ['./termo.component.scss'],
})
export class TermoComponent implements OnInit {
  isDesktop: boolean;
  isTablet: boolean;

  constructor(
    private modalCtrl: ModalController,
    private platform: Platform,
  ) { }

  ngOnInit() {
    this.platform.ready();

    this.isDesktop = this.platform.is('desktop') &&
      !this.platform.is('mobile') &&
      !this.platform.is('mobileweb');

  }

  fecharClicked() {
    this.modalCtrl.dismiss();
  }

}
